import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { PageSpinnerService } from './services/page-spinner.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-page-spinner',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './page-spinner.component.html',
  styleUrl: './page-spinner.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom
})

export class PageSpinnerComponent {
  readonly logoUrl = `${environment.buzzwaveAdminAssetsS3Url}/buzzwave-logo-middle.png`;
  constructor(public loader: PageSpinnerService) {}
}
